import StepItemRow from "./StepItemRow";

/**
 * StepFolderGrid
 * 폴더별로 그룹화된 항목 카드들을 그리드/스택으로 렌더링.
 *
 * PC     : auto-fill grid (한 행에 여러 폴더 카드)
 * Mobile : 1열 세로 스택 (폴더 탐색/접기 우선)
 */
export default function StepFolderGrid({
  groupedFolderOptions,
  selSteps,
  openFolders,
  isMobile,
  onToggleFolder,
  onToggleStep,
  onAddTarget,
  onRemoveTarget,
  onUpdateTarget,
  onUpdateStep,
}) {
  const isEmpty = Object.keys(groupedFolderOptions).length === 0;

  const containerStyle = isMobile
    ? { display: "flex", flexDirection: "column", gap: 10, marginBottom: 10 }
    : {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(380px, 1fr))",
        gap: 10,
        marginBottom: 10,
        alignItems: "start",
      };

  if (isEmpty) {
    return (
      <div style={containerStyle}>
        <div style={{ fontSize: 14, color: "#0f172a", textAlign: "center", padding: "10px 0" }}>
          등록된 항목이 없습니다. 상단의 '➕ 항목 추가'를 눌러 항목을 생성해주세요.
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      {Object.entries(groupedFolderOptions).map(([folderName, options]) => {
        const isFolderOpen = !!openFolders[folderName];
        return (
          <div
            key={folderName}
            style={{
              background: "#f8fafc",
              padding: 10,
              borderRadius: 8,
              border: "0.5px solid #e2e8f0",
            }}
          >
            {/* 아코디언 헤더 — 모바일은 폭 전체를 탭 영역으로 */}
            <div
              onClick={() => onToggleFolder(folderName)}
              style={{
                fontSize: isMobile ? 15 : 14,
                fontWeight: 600,
                color: "#0f172a",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 6,
                userSelect: "none",
                marginBottom: isFolderOpen ? 8 : 0,
                padding: isMobile ? "4px 2px" : 0,
              }}
            >
              <span>
                {isFolderOpen ? "📂" : "📁"} {folderName}
              </span>
              <span style={{ fontSize: 11, color: "#64748b", fontWeight: "normal" }}>
                {isFolderOpen ? "접기 ▲" : "펼치기 ▼"}
              </span>
            </div>

            {isFolderOpen && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {options.map((opt) => (
                  <StepItemRow
                    key={opt.key}
                    opt={opt}
                    sel={selSteps.find((s) => s.key === opt.key)}
                    isMobile={isMobile}
                    onToggle={onToggleStep}
                    onAddTarget={onAddTarget}
                    onRemoveTarget={onRemoveTarget}
                    onUpdateTarget={onUpdateTarget}
                    onUpdateStep={onUpdateStep}
                  />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}